import { FormControl, FormGroup, Validators } from '@angular/forms';

import type { BaseObjectModel } from '@app/shared/models/base.model';

export interface ProjectMemberUser {
    id: number;
    name: string;
    email: string;
    visibleName: string;
}

export interface ProjectMemberTeam {
    id: number;
    name: string;
    description?: string | null;
    users?: ProjectMemberUser[];
}

export interface ProjectMemberRoleAdapter {
    id: number;
    userId?: number | null;
    readonly user?: ProjectMemberUser | null;
    teamId?: number | null;
    readonly team?: ProjectMemberTeam | null;
    projectRoleId: number;
    projectRoleName: string;
    pendingAccess: boolean;
}

export interface ProjectAdapter extends BaseObjectModel {
    // Auditable:
    readonly createdBy?: null | string;
    readonly createdDate?: string;
    readonly lastModifiedBy?: null | string;
    readonly lastModifiedDate?: string;

    slug?: string; // We add slug in backend
    description: string;
}

export type ProjectFormGroup = ReturnType<typeof getProjectForm>;

export function getProjectForm(item: ProjectAdapter) {
    return new FormGroup({
        id: new FormControl(item.id || null),
        name: new FormControl(item.name || '', [
            Validators.required,
            Validators.pattern(/^[^()]*$/),
        ]),
        description: new FormControl(item.description || ''),
    });
}

export function getProjectForAPI(
    formValue: DeepReadonly<ProjectFormGroup['value']>,
): ProjectAdapter {
    return {
        id: formValue.id,
        name: formValue.name || '',
        description: formValue.description || '',
        comment: '',
    };
}
